import { render } from "./aDirectorForm.vue?vue&type=template&id=56334dd1&scoped=true"
import script from "./aDirectorForm.vue?vue&type=script&lang=js"
export * from "./aDirectorForm.vue?vue&type=script&lang=js"

import "./aDirectorForm.vue?vue&type=style&index=0&id=56334dd1&lang=css&scoped=true"

import exportComponent from "D:\\xampp\\htdocs\\jump\\front\\jumpsa\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56334dd1"]])

export default __exports__